"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.If = void 0;
var If = exports.If = function If(props) {
  return props.condition ? props.render ? props.render() : props.children : null;
};